import { get, some } from 'lodash';

export const isVendorPartner = (company) =>
  company.affiliated.employer && company.affiliated.supplier;

export const companyType = (company) => {
  if (isVendorPartner(company)) {
    return 'vendorPartner';
  }

  return 'vendor';
};

export const isAffiliated = ({ affiliated }) =>
  affiliated.employer || affiliated.supplier;

export const shouldShowPerformance = (company, affiliation) => {
  if (company.affiliated[affiliation]) {
    return true;
  }

  const performance = get(
    company.performance,
    affiliation === 'employer' ? 'from' : 'to',
    {}
  );
  return some(performance, (value) => value !== null && value !== 0);
};
